import { graphql } from '@apollo/react-hoc';
import { capitalize } from 'lodash';
import moment from 'moment';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { ExportExcelButton } from 'components/ExportExcelButton/ExportExcelButton';
import { query } from '../gql/queries/get-list';

const Container = styled.button`
  border-radius: 5px;
  background-color: #fa4616;
  color: #fff;
  box-sizing: border-box;
  padding: 15px;
  border: none;
  width: calc(100% - 20px);
  margin: 0 10px 0 10px;

  &:focus {
    outline: none;
  }

  @media (min-width: 860px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 10px 0 10px;
    background-color: transparent;
    cursor: pointer;
    width: auto;
  }
`;

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

const TextListExport = ({ button, data, loading, error }) => {
  const getData = async () => {
    try {
      if (data?.getList) {
        return data.getList;
      }
      return null;
    } catch (e) {
      console.warn(e);
      return null;
    }
  };

  const exportListCSV = async () => {
    const listData = await getData();

    if (!listData || !listData.recipients || listData.recipients.length === 0) {
      alert('No data available to export');
      return;
    }

    // Generate dynamic headers from first recipient's data
    const firstRecipient = listData.recipients[0];
    const dynamicHeaders = ['ID', 'Cellphone'];

    if (firstRecipient.data && firstRecipient.data.length > 0) {
      firstRecipient.data.forEach((dataItem) => {
        dynamicHeaders.push(capitalize(dataItem.key));
      });
    }

    // Create CSV header row
    const headers =
      dynamicHeaders.map((header) => `"${header}"`).join(',') + '\n';

    // Create CSV data rows
    const dataRows = listData.recipients
      .map((recipient) => {
        const row = [recipient.id, recipient.cellphone || ''];

        // Add dynamic data fields
        if (firstRecipient.data && firstRecipient.data.length > 0) {
          firstRecipient.data.forEach((dataItem) => {
            const recipientDataItem = recipient.data?.find(
              (d) => d.key === dataItem.key
            );
            row.push(recipientDataItem ? recipientDataItem.value : '');
          });
        }

        return row.map((field) => `"${field}"`).join(',');
      })
      .join('\n');

    const dateTimeStamp = moment().format('MMM DD - YYYY h:mm A');

    const csv = `List Export Report
List Name:, ${listData.name}
Exported:, ${dateTimeStamp}
Total Recipients:, ${listData.recipients.length}

${headers}${dataRows}`;

    const filename = `${moment().format('ddd MMM D - YYYY')} - ${
      listData.name
    } - List Export.csv`;

    download(filename, csv.trim());
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  return (
    <Container onClick={() => exportListCSV()}>
      {button ? <div>{button}</div> : <ExportExcelButton />}
    </Container>
  );
};

export default withTheme(
  graphql(query, {
    options: ({ listId }) => ({
      variables: { id: Number(listId) || 0 },
      fetchPolicy: 'cache-and-network',
    }),
  })(TextListExport)
);
